<template>
  <div>
    <CreateSenderPopup :isActive="isDetailsActive" @close="toggleDetails" />
    <b-card no-body class="rounded-xl border-none">
      <div class="mb-4 flex justify-end">
        <base-button outline type="success" @click="toggleDetails(true)"
          >Create Sender ID</base-button
        >
      </div>

      <div class="mt-8">
        <b-input-group>
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            min="0.00"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
        <el-table
          class="table-responsive table-flush mt-6"
          header-row-class-name="thead-light table-th-color"
          :data="DLTData"
        >
          <el-table-column label="SNo" min-width="120px" prop="vid" sortable>
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.vid }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="User ID"
            min-width="140px"
            prop="name"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.name }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Sender ID / Header"
            min-width="180px"
            prop="senderID"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.senderID }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Submited On"
            min-width="140px"
            prop="submitted"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.submitted }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Status"
            min-width="140px"
            prop="status"
            sortable
          >
            <template v-slot="{ row }">
              <span class="text-black font-medium">{{ row.status }}</span>
            </template>
          </el-table-column>

          <el-table-column
            label="Action"
            min-width="100px"
            prop="action"
            sortable
          >
            <template>
              <div class="flex items-center">
                <div class="flex items-center cursor-pointer">
                  <feather-icon
                    icon="Trash2Icon"
                    svgClasses="w-5"
                    data-toggle="tooltip"
                    data-placement="top"
                    title="Delete"
                  ></feather-icon>
                </div>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <b-card-footer class="py-4 d-flex justify-content-end">
          <base-pagination
            v-model="currentPage"
            :per-page="10"
            :total="50"
          ></base-pagination>
        </b-card-footer>
      </div>
    </b-card>
  </div>
</template>
<script>
import DLTData from "./DLTData";
import CreateSenderPopup from "./CreateSenderPopup";
import {
  Table,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
} from "element-ui";
export default {
  name: "light-table",
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    CreateSenderPopup,
  },
  data() {
    return {
      DLTData,
      currentPage: 1,
      isDetailsActive: false,
      isShowCreate: false,
    };
  },
  methods: {
    toggleDetails(val = false) {
      this.isDetailsActive = val;
    },
  },
};
</script>
